import React, { useEffect, useState } from 'react'
import fetchData from '../../../function/fetchData'
import { useNavigate } from 'react-router-dom'
import CloseButton from 'react-bootstrap/CloseButton'
import { Modal, Button, Form } from 'react-bootstrap'

const UserList = ({ server }) => {
    const navigate = useNavigate()
    const [token, setToken] = useState(null)
    const [dataFromServer, setDataFromServer] = useState([])
    const [showModal, setShowModal] = useState(false)
    const [selectedDriver, setSelectedDriver] = useState(null)
    const [formData, setFormData] = useState({})

    // Načti token
    useEffect(() => {
        const data = localStorage.getItem('driverToken')
        if (data) setToken(data)
    }, [])

    // Načti data
    useEffect(() => {
        if (token) {
            fetchData(server + 'api2/adminDriverController.php', {
                token,
                action: 'GET_DRIVERS'
            }).then(res => setDataFromServer(res.payload))
        }
    }, [token])

    const handleEdit = (driver) => {
        setSelectedDriver(driver)
        setFormData(driver)
        setShowModal(true)
    }

    const handleChange = (e) => {
        setFormData(prev => ({
            ...prev,
            [e.target.name]: e.target.value
        }))
    }

    const handleSave = () => {
        // Validace – všechna pole musí být vyplněná
        const requiredFields = ['nick', 'tel', 'email', 'spz', 'type'];
        const missing = requiredFields.filter(key => !formData[key]?.trim());

        if (missing.length > 0) {
            alert('Vyplňte všechna pole: ' + missing.join(', '));
            return;
        }

        const action = formData.id ? 'UPDATE' : 'CREATE';

        fetchData(server + 'api2/adminDriverController.php', {
            token,
            action,
            ...formData
        }).then(res => {
            if (res.success) {
                setShowModal(false)
                if (action === 'CREATE') {
                    setDataFromServer(prev => [...prev, res.driver]);
                } else {
                    setDataFromServer(prev =>
                        prev.map(item =>
                            item.id === formData.id ? { ...item, ...formData } : item
                        )
                    );
                }
            } else {
                alert('Chyba: ' + res.message);
            }
        })
    }

    const handleDelete = (id) => {
        if (!window.confirm('Opravdu chcete tohoto řidiče smazat?')) return;

        fetchData(server + 'api2/adminDriverController.php', {
            token,
            action: 'DELETE',
            id
        }).then(res => {
            if (res.success) {
                setDataFromServer(prev => prev.filter(driver => driver.id !== id));
            } else {
                alert('Nepodařilo se smazat řidiče: ' + res.message);
            }
        })
    }



    return (
        <div>
            <div className='top'>
                <div style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
                    <h2>Správa řidičů</h2>
                    <Button variant="success" onClick={() => {
                        setSelectedDriver(null);
                        setFormData({ nick: '', tel: '', email: '', spz: '', type: '' });
                        setShowModal(true);
                    }}>Přidat řidiče</Button>
                </div>
                <CloseButton onClick={() => navigate('/admin')} />
            </div>

            <div style={{ padding: 20 }}>
                {dataFromServer.map(driver => (
                    <div key={driver.id} style={{ borderBottom: '1px solid #ccc', padding: 10, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <div>
                            <strong>{driver.nick}</strong> – {driver.spz} – {driver.tel}
                        </div>
                        <div style={{ display: 'flex', gap: '8px' }}>
                            <Button variant="outline-primary" size="sm" onClick={() => handleEdit(driver)}>Upravit</Button>
                            <Button variant="outline-danger" size="sm" onClick={() => handleDelete(driver.id)}>Smazat</Button>
                        </div>
                    </div>
                ))}
            </div>

            <Modal show={showModal} onHide={() => setShowModal(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Upravit řidiče</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group className="mb-3">
                            <Form.Label>Přezdívka</Form.Label>
                            <Form.Control type="text" name="nick" value={formData.nick || ''} onChange={handleChange} />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Telefon</Form.Label>
                            <Form.Control type="text" name="tel" value={formData.tel || ''} onChange={handleChange} />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>SPZ</Form.Label>
                            <Form.Control type="text" name="spz" value={formData.spz || ''} onChange={handleChange} />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Email</Form.Label>
                            <Form.Control type="email" name="email" value={formData.email || ''} onChange={handleChange} />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Typ vozu</Form.Label>
                            <Form.Control type="text" name="type" value={formData.type || ''} onChange={handleChange} />
                        </Form.Group>
                        {/* můžeš přidat další pole dle potřeby */}
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowModal(false)}>Zavřít</Button>
                    <Button variant="primary" onClick={handleSave}>Uložit</Button>
                </Modal.Footer>
            </Modal>

        </div>
    )
}

export default UserList
